import type { TicketSalesTour } from '@app-types/ticketSales';
import type { ImmerStateCreator } from '../../immerStateCreator';

export type TourInformation = Omit<TicketSalesTour, 'venues'>;

export interface TourInformationState {
  tourInformation?: TourInformation;
}

export interface TourInformationActions {
  initializeTourInformation: (tourInformation: TourInformation) => void;
}

export type TourInformationStore = TourInformationState & TourInformationActions;

export const createTourInformationSlice: ImmerStateCreator<TourInformationStore> = (set) => ({
  tourInformation: undefined,
  initializeTourInformation: (tourInformation) =>
    set(
      (state) => {
        state.tourInformation = tourInformation;
      },
      false,
      'ticketingSales/initializeTourInformation',
    ),
});
